module.exports = __webpack_public_path__ + "assets/img/web03.029473a1.png";